import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SearchModule } from '../../components/search/search.module';
import { PipeModule } from '../../pipes/pipes.module';
import { ConflictsModule } from '../conflicts/conflicts.module';
import { GroupsListComponent } from './components/groups-list/groups-list.component';

const components: Type<any>[] = [
	GroupsListComponent
]

@NgModule({
	declarations: components,
	imports: [
		CommonModule,
		IonicModule,
		PipeModule,
		SearchModule,
		ConflictsModule
	],
	exports: components
})
export class GroupsModule { }
